import { Client, cacheExchange, fetchExchange } from 'urql';

// Store recreation callback
let recreationCallback: (() => void) | null = null;

const getClient = ({ token }: { token: string }) => {
  const client = new Client({
    url: '/social_graphql',
    exchanges: [cacheExchange, fetchExchange],
    fetchOptions: {
      headers: {
        authorization: `Bearer ${token}`,
      },
    },
  });

  return client;
};

// Function to recreate the client and trigger re-renders
export const recreateClient = () => {
  if (recreationCallback) {
    recreationCallback();
  }
};

// Function to register the recreation callback from the provider
export const setClientRecreationCallback = (callback: () => void) => {
  recreationCallback = callback;
};

export default getClient;
